import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import {
  composeQueryParams,
  initialDashboardPageMetadata,
  mergeDshbPageMetadataObjects,
  paramsSerializer
} from "../../utils";

export const readModerationContentsAsync = createAsyncThunk(
  "moderation/readContents",
  async (payload = {}, { getState }) => {
    const { contentMetadata } = getState().moderation;
    const params = composeQueryParams(payload, contentMetadata);
    const response = await axios.get("/api/admin/moderation/contents", { params, paramsSerializer });
    return response.data;
  }
);

export const readModerationUsersAsync = createAsyncThunk(
  "moderation/readUsers",
  async (payload = {}, { getState }) => {
    const { userMetadata } = getState().moderation;
    const params = composeQueryParams(payload, userMetadata);
    const response = await axios.get("/api/admin/moderation/users", { params, paramsSerializer });
    return response.data;
  }
);

export const reviewContentAsync = createAsyncThunk(
  "moderation/reviewContent",
  async ({ id, action }) => {
    const response = await axios.post(`/api/admin/moderation/contents/${id}/review`, { action });
    return { id, action, data: response.data };
  }
);

export const reviewUserAsync = createAsyncThunk(
  "moderation/reviewUser",
  async ({ id, action }) => {
    const response = await axios.post(`/api/admin/moderation/users/${id}/review`, { action });
    return { id, action, data: response.data };
  }
);

export const moderationSlice = createSlice({
  name: "moderation",
  initialState: {
    contentLoading: false,
    userLoading: false,
    contents: [],
    users: [],
    contentMetadata: initialDashboardPageMetadata,
    userMetadata: initialDashboardPageMetadata
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(readModerationContentsAsync.pending, state => {
        state.contentLoading = true;
      })
      .addCase(readModerationContentsAsync.fulfilled, (state, action) => {
        state.contentLoading = false;
        const { items, ...metadata } = action.payload || {};
        state.contents = items || [];
        state.contentMetadata = mergeDshbPageMetadataObjects(state.contentMetadata, metadata);
      })
      .addCase(readModerationContentsAsync.rejected, state => {
        state.contentLoading = false;
      })
      .addCase(readModerationUsersAsync.pending, state => {
        state.userLoading = true;
      })
      .addCase(readModerationUsersAsync.fulfilled, (state, action) => {
        state.userLoading = false;
        const { items, ...metadata } = action.payload || {};
        state.users = items || [];
        state.userMetadata = mergeDshbPageMetadataObjects(state.userMetadata, metadata);
      })
      .addCase(readModerationUsersAsync.rejected, state => {
        state.userLoading = false;
      })
      .addCase(reviewContentAsync.fulfilled, (state, action) => {
        const { id, action: reviewAction } = action.payload;
        const status = reviewAction === "approve" ? "approved" : "rejected";
        state.contents = state.contents.map(c =>
          c.id === id ? { ...c, moderationStatus: status } : c
        );
      })
      .addCase(reviewUserAsync.fulfilled, (state, action) => {
        const { id, action: reviewAction } = action.payload;
        const status = reviewAction === "approve" ? "approved" : "rejected";
        state.users = state.users.map(u =>
          u.id === id ? { ...u, moderationStatus: status } : u
        );
      });
  }
});

export default moderationSlice.reducer;
